import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import AddCircle from "@material-ui/icons/AddCircle";
import { IconButton } from "@material-ui/core";

import List from "@material-ui/core/List";

import Item from "./item";
import Nuevo from "./nuevo";

import { useQuery } from "@apollo/react-hooks";

import { ETIQUETAS } from "./../../graphql/etiquetas.query";
import { CREATE_ETIQUETA } from "./../../graphql/etiquetas.mutation";
import { useMutation } from "@apollo/react-hooks";

const ITEMS_LIMIT = 40;

export default function EtiquetaDialog({ aceptar, allSelected = [] }) {
  const [open, setOpen] = React.useState(false);

  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(false);

  const { data } = useQuery(ETIQUETAS, {
    variables: {
      limit: ITEMS_LIMIT,
      offset: 0,
      nombre: value,
    },
    notifyOnNetworkStatusChange: true,
  });

  const [createEtiqueta] = useMutation(CREATE_ETIQUETA, {
    onCompleted: (data) => {
      if (data && data.createEtiqueta) {
        setValue(data.createEtiqueta.nombre);
      }
      setLoading(false);
    },
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <IconButton
        onClick={handleClickOpen}
        color="primary"
        aria-label="upload picture"
        component="span"
      >
        <AddCircle />
      </IconButton>
      <Dialog
        open={open}
        scroll={"paper"}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          <div style={{ display: "flex-root" }}>
            <div>Etiquetas</div>
            <div>
              <span style={{ fontSize: "16px" }}>Buscar...</span>{" "}
              <input
                style={{
                  height: "30px",
                  padding: "4px",
                  borderRadius: "4px",
                  width: "70%",
                }}
                onChange={(e) => setValue(e.target.value)}
              />
            </div>
          </div>
        </DialogTitle>
        <DialogContent
          dividers={true}
          // onScroll={e => handleScroll(e, loadMore)}
        >
          <DialogContentText style={{ height: "300px" }}>
            {loading && <span>Cargando...</span>}
            {!loading &&
              data &&
              data.etiquetas &&
              data.etiquetas.map((item) => (
                <Item
                  key={item._id}
                  agregar={() => aceptar(item.nombre)}
                  data={item}
                  enabled={
                    allSelected.findIndex((i) => i === item.nombre) === -1
                  }
                />
              ))}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <List>
            <Nuevo
              aceptar={(nombre) => {
                if (nombre.length > 0) {
                  setLoading(true);
                  createEtiqueta({
                    variables: {
                      etiqueta: { nombre },
                    },
                  });
                }
              }}
            />
          </List>
        </DialogActions>
      </Dialog>
    </div>
  );
}
